import { animalStore, syncQueue, idMapStore } from '../indexedDBService'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export async function syncAnimals() {
	const keys = await syncQueue.keys()

	for (const key of keys) {
		const action = await syncQueue.getItem(key)

		if (!action || !action.type) continue

		try {
			if (action?.type === 'ANIMAL_ADD_OFFLINE') {
				try {
					if (action.payload?.lot?.length > 20) {
						const resolvedId = await idMapStore.getItem(action.payload.lot)
						if (resolvedId) action.payload.lot = resolvedId
					}

					const { data, status } = await Axios.post('/api/animal/register', action.payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await animalStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar animal offline:', error)
				}
			}

			if (action?.type === 'ANIMAL_EDIT_OFFLINE') {
				try {
					if (action.payload?.lot?.length > 20) {
						const resolvedId = await idMapStore.getItem(action.payload.lot)
						if (resolvedId) action.payload.lot = resolvedId
					}

					const { data, status } = await Axios.put('/api/animal/edit/' + key, action.payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200 || status === 264) {
						await syncQueue.removeItem(key)
						await animalStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar edición de animal:', error)
				}
			}
		} catch (error) {
			console.warn(`Error al sincronizar acción offline (${action.type}):`, error)
		}
	}
}